import React from 'react';

function DragMarker({ children }) {
    return <div className="dragmarker _pe-none">{children}</div>;
}

export default DragMarker;
